import { render, staticRenderFns } from "./AddGroup.vue?vue&type=template&id=6c9364d2&scoped=true"
import script from "./AddGroup.vue?vue&type=script&lang=ts"
export * from "./AddGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9364d2",
  null
  
)

export default component.exports